
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
import DatePicker from "@/components/DatePicker.vue";
import moment from "moment";

@Component({
	components: {
		DatePicker,
	},
})
export default class OrderedMaterialsReport extends Vue {
	private report: any = {};
	private loading: boolean = false;
	// private startDate: string = moment().format('YYYY-01-01');
	private endDate: string = moment().format("YYYY-MM-DD");
	private startDate: string = moment().subtract(3, "month").format("YYYY-MM-01");
	private deviationThreshold: number = 5; // in CHF/EUR. When is it considered different to expected.
	private pagination: any = {
		rowsPerPage: 25,
	};
	private headers: any = [
		{
			text: "Blexon Order Id",
			width: "20px",
			value: "blexonOrderId",
			sortable: true,
		},
		{
			text: "Transport-Provider",
			value: "transportProviderName",
			sortable: true,
		},
		{
			text: "Offerierte Transportkosten (ohne Margen)",
			value: "customerCost",
			sortable: true,
		},
		{
			text: "Effektive Transportkosten (an Transporteur bezahlt)",
			value: "blexonCost",
			sortable: true,
		},
		{
			text: "Rechnungsbetrag",
			value: "invoiceAmount",
			sortable: true,
		},
		{
			text: "Differenz",
			value: "costDifference",
			sortable: true,
		},
		{
			text: "Geschätzte Höhe [mm]",
			value: "predictedHeight",
			sortable: false,
		},
	];

	private mounted() {
		this.loadReport();
	}

	private setStartDate(date: Date) {
		this.startDate = moment(date).format("YYYY-MM-DD");
	}
	private setEndDate(date: Date) {
		this.endDate = moment(date).format("YYYY-MM-DD");
	}

	private get filteredOrders() {
		if (!this.report || !this.report.orderCosts) return [];
		let filtered = this.report.orderCosts.filter(
			(order: any) => Math.abs(order.costDifference) > this.deviationThreshold
		);
		return filtered;
	}

	private get groupedOrders() {
		if (!this.report || !this.report.orderCosts) return [];
		const grouped = this.report.orderCosts.reduce(
			(result: any, order: any) => {
				if (!result[order.transportProviderName]) {
					result[order.transportProviderName] = { correct: 0, incorrect: 0 };
				}
				if (Math.abs(order.costDifference) > this.deviationThreshold) {
					result[order.transportProviderName].incorrect++;
				} else {
					result[order.transportProviderName].correct++;
				}
				return result;
			},
			{} as Record<string, { correct: number; incorrect: number }>
		);

		return Object.entries(grouped).map(([provider, counts]: [string, any]) => ({
			provider,
			correct: counts.correct,
			incorrect: counts.incorrect,
		}));
	}

	@Watch("startDate")
	@Watch("endDate")
	private async loadReport() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Report/GetTransportCostReport?from=${this.startDate}&to=${this.endDate}`
			);
			this.report = response.data;
		} catch (err) {
			console.error("Loading transport cost report failed.");
			console.error(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Reports. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}
}
